import {AsyncComponent} from '@modifi/code-splitting'
import {FullScreenLoader} from '@modifi/ui'

export const CompanyDocumentsPage = AsyncComponent({
  importThunk: () => import(/* webpackChunkName: "company-documents" */ './company-documents'),
  loader: FullScreenLoader,
})

export const CompanyFinancialDocumentsPage = AsyncComponent({
  importThunk: () => import(/* webpackChunkName: "company-documents" */ './financial-documents'),
  loader: FullScreenLoader,
})

export const CompanyGroupFinancialDocumentsPage = AsyncComponent({
  importThunk: () =>
    import(/* webpackChunkName: "company-documents" */ './group-financial-documents'),
  loader: FullScreenLoader,
})

export const CompanyOtherDocumentsPage = AsyncComponent({
  importThunk: () => import(/* webpackChunkName: "company-documents" */ './other-documents'),
  loader: FullScreenLoader,
})
